// extracted by mini-css-extract-plugin
export var alertIcon = "_rt-0";